<template lang="pug">
  v-app#inspire
    v-navigation-drawer(v-model='drawer', :clipped='$vuetify.breakpoint.lgAndUp', app='')
      v-list
        v-subheader
          v-list-item(to='/home')
            v-list-item-action
              v-icon mdi-home-import-outline
            v-list-item-content
              v-list-item-title Inicio
        v-list-group(v-for='(item, i) in itemsPer' no-action :prepend-icon="item.icon2")
          template(v-slot:activator)
            v-list-item-content
              v-list-item-title {{ item.text }}
          v-list(v-for='(arr, i) in item.array', class="py-0")
            v-list-group(v-if="arr.subItems" :sub-group="arr.subItems")
              template(v-slot:activator)
                v-list-item-content
                  v-list-item-title {{ arr.text }}
              v-list-item(v-if="arr.subItems" v-for='(child, i) in arr.children', :to='{name: child.ruta }')
                v-list-item-action(v-if='child.icon')
                  v-icon {{ child.icon }}
                v-list-item-content
                  v-list-item-title {{ child.name }}
            v-list-item(v-else :sub-group="arr.subItems" :to='{name: arr.ruta }')
              v-list-item-action
                v-icon {{ arr.icon }}
              v-list-item-content
                  v-list-item-title {{ arr.name }}
        v-subheader(v-for='(item, i) in items2Per' no-action)
          v-list-item(:to='{name: item.ruta }' style='position:relative;')
            div(v-if='noti' style='width:20px;height:20px; background-color:black;background-color: #26a69a;border-radius: 100%;position: absolute;top: 5px;right: 5px;')
              v-icon(style='color: white;font-size: 16px;margin-left: 2px;margin-bottom: 2px;') {{ item.icon }}
            v-list-item-action
              v-icon(v-if='noti' style='margin-right:17px;') {{ item.icon2 }}
              v-icon(v-if='!noti') {{ item.icon2 }}
            v-list-item-content
              v-list-item-title {{ item.name }}
    v-app-bar(:clipped-left='$vuetify.breakpoint.lgAndUp', app='', color='teal lighten-1', dark='')
      v-toolbar-title.ml-0.pl-4(style='width: 30%')
        v-app-bar-nav-icon(@click.stop='drawer = !drawer')
        span.hidden-sm-and-down {{ nameEmpresa }}
        //- span.hidden-sm-and-down Sistema Administrativo
      v-text-field(style="margin-top: 2rem;width: 1rem;" dense outlined readonly v-model.number='tasa' label='Tasa del día' @click='actualizarTasa(tasa)')
      v-spacer
      .text-center
        v-flex.d-flex
          v-menu(top :close-on-content-click='closeOnContentClick')
            template(v-slot:activator='{ on }')
              v-btn(icon='', v-on='on')
                v-icon mdi-home-currency-usd
            v-list(min-width="250")
              v-list-item(v-for='(item, index) in idEmpresaArray', @click='aceptar(item.value)')
                v-list-item-title {{ item.text }}
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-btn(icon='', to='/Configuracion' v-on="on")
                v-icon mdi-settings
            | Configuración
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-btn(icon='', @click='logout' v-on="on")
                v-icon mdi-logout
            | Cerrar Sesión
    v-dialog(v-model='dialog', persistent max-width='30%')
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          span.headline Tasa de cambio del día
        v-card-text
          v-row(dense)
            v-col(cols='12')
              v-card(color='white')
                v-card-text
                  v-row(dense)
                    v-col(cols='12' sm='12' md='12')
                      v-text-field(dense outlined v-model.number='tasa' @click='limpiar()' min="0")
        v-card-actions
          v-spacer
          v-btn(color='error', small dark @click='close')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success', small dark @click='save()')
            v-icon mdi-content-save
            | Guardar
    v-main
      v-container.fill-height(fluid='')
        router-view
</template>
<script>
import Api from '@/services/methods'
import { EventBus } from '../Events'
import { formatoDecimal } from '@/helpers/index'
export default {
  props: {
    source: String
  },
  data: () => ({
    nameEmpresa: '',
    tasaD: [],
    tasa: 0,
    noti: false,
    dialog: false,
    drawer: null,
    idEmpresaArray: [],
    master: '',
    model: {
      idempresa: ''
    },
    arrayPermisos: [
      {
        model: false,
        children: []
      }
    ],
    closeOnContentClick: true,
    items: [
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-chart-bar ',
        text: 'Operaciones',
        model: false,
        array: [
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Productos',
            model: false,
            subItems: true,
            num: 3,
            children: [
              {
                num: 1,
                icon: 'mdi-cart',
                permiso: 'Producto',
                ruta: 'Producto',
                name: 'Ver'
              },
              {
                num: 2,
                icon: 'mdi-cart',
                permiso: 'AjustePrecio',
                ruta: 'AjustePrecio',
                name: 'Ajuste de Precio'
              },
              {
                num: 3,
                icon: 'mdi-cart',
                permiso: 'Serial',
                ruta: 'Serial',
                name: 'Seriales'
              },
              {
                num: 4,
                icon: 'mdi-cart',
                permiso: 'UnidadVenta',
                ruta: 'UnidadVenta',
                name: 'Unidades de Venta'
              },
              {
                num: 5,
                icon: 'mdi-cart',
                permiso: 'PresentacionProd',
                ruta: 'PresentacionProd',
                name: 'Presentaciones'
              },
              {
                num: 6,
                icon: 'mdi-cart',
                permiso: 'Producto',
                ruta: 'ConsultaPro',
                name: 'Consultar Precio'
              }
            ]
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Fabricantes',
            model: false,
            subItems: true,
            num: 5,
            children: [
              {
                num: 1,
                icon: 'mdi-cart-arrow-down',
                permiso: 'Fabricante',
                ruta: 'Fabricante',
                name: 'Ver'
              },
              {
                num: 2,
                icon: 'mdi-cart-arrow-down',
                permiso: 'Linea',
                ruta: 'Linea',
                name: 'Categorias'
              },
              {
                num: 3,
                icon: 'mdi-approximately-equal-box ',
                permiso: 'Marca',
                ruta: 'Marca',
                name: 'Marcas'
              }
            ]
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Inventario',
            model: false,
            subItems: true,
            num: 4,
            children: [
              {
                num: 1,
                icon: 'mdi-cart',
                permiso: 'Ajuste',
                ruta: 'Ajuste',
                name: 'Ajuste de Inventario'
              },
              {
                num: 2,
                icon: 'mdi-clipboard-list-outline ',
                permiso: 'Kardex',
                ruta: 'Kardex',
                name: 'Kardex'
              },
              {
                num: 3,
                icon: 'mdi-warehouse',
                permiso: 'TransferirAlmacen',
                ruta: 'TransferirAlmacen',
                name: 'Transferencias entre almacenes'
              }
            ]
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Despacho',
            model: false,
            subItems: true,
            num: 6,
            children: [
              {
                num: 1,
                icon: 'mdi-truck',
                permiso: 'Despacho',
                ruta: 'Despacho',
                name: 'Ver'
              },
              {
                num: 2,
                icon: 'mdi-truck-check',
                permiso: 'Despacho',
                ruta: 'LiquidacionDespacho',
                name: 'Liquidacion Despacho'
              },
              {
                num: 3,
                icon: 'mdi-dolly',
                permiso: 'Despacho',
                ruta: 'LiquidacionAlmacen',
                name: 'Liquidacion Almacen'
              }
            ]
          },
          {
            icon: 'mdi-truck-delivery-outline',
            permiso: 'Vehiculo',
            ruta: 'Vehiculo',
            name: 'Transporte',
            model: false,
            subItems: false,
            num: 8
          },
          {
            icon: 'mdi-newspaper-plus',
            permiso: 'OrdenCompra',
            ruta: 'OrdenCompra',
            name: 'Ordenes',
            model: false,
            subItems: false,
            num: 1
          },
          {
            icon: 'mdi-cart-arrow-down',
            permiso: 'Compra',
            ruta: 'Compra',
            name: 'Compras',
            model: false,
            subItems: false,
            num: 2
          },
          {
            icon: 'mdi-warehouse',
            permiso: 'Almacen',
            ruta: 'Almacen',
            name: 'Almacenes',
            model: false,
            subItems: false,
            num: 5
          },
          {
            icon: 'mdi-warehouse',
            permiso: 'Almacen',
            ruta: 'ValorInventario',
            name: 'Valor de Inventario',
            model: false,
            subItems: false,
            num: 5
          },
          {
            icon: 'mdi-clipboard-list-outline',
            permiso: 'OrdenxCotizar',
            ruta: 'OrdenxCotizar',
            name: 'Ordenes por cotizar',
            model: false,
            subItems: false,
            num: 9
          },
          {
            icon: 'mdi-clipboard-list-outline',
            permiso: 'OrdenesDeCotizacion',
            ruta: 'OrdenesDeCotizacion',
            name: 'Ordenes de cotización',
            model: false,
            subItems: false,
            num: 10
          },
          {
            icon: 'mdi-account-cash',
            permiso: 'Proveedor',
            ruta: 'Proveedor',
            name: 'Proveedores',
            model: false,
            subItems: false,
            num: 7
          },
          {
            icon: 'mdi-account-tie',
            permiso: 'Importacion',
            ruta: 'Consignado',
            name: 'Consignado',
            model: false,
            subItems: false,
            num: 11
          },
          {
            icon: 'mdi-factory',
            permiso: 'Importacion',
            ruta: 'Naviera',
            name: 'Naviera',
            model: false,
            subItems: false,
            num: 12
          },
          {
            icon: 'mdi-map-search-outline ',
            permiso: 'Importacion',
            ruta: 'PaisesImportacion',
            name: 'Países',
            model: false,
            subItems: false,
            num: 14
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-square-inc-cash ',
        text: 'Tesoreria',
        model: false,
        array: [
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Reportes',
            model: false,
            subItems: true,
            num: 9,
            children: [
              {
                num: 1,
                icon: 'mdi-cart',
                permiso: 'CuentaPorCobrarReporte',
                ruta: 'CuentaPorCobrarReporte',
                name: 'Cuentas por Cobrar'
              },
              {
                num: 2,
                icon: 'mdi-clipboard-list-outline ',
                permiso: 'AnalisisVencimiento',
                ruta: 'AnalisisVencimiento',
                name: 'Analisis de Vencimiento'
              },
              {
                num: 3,
                icon: 'mdi-clipboard-list-outline ',
                permiso: 'AnalisisVencimiento',
                ruta: 'LibroVentas',
                name: 'Libro de Ventas'
              },
              {
                num: 4,
                icon: 'mdi-clipboard-list-outline ',
                permiso: 'AnalisisVencimiento',
                ruta: 'ReporteGerencia',
                name: 'Reporte de Gerencia'
              }
            ]
          },
          {
            num: 1,
            icon: 'mdi-cart',
            permiso: 'CuentaPorCobrar',
            ruta: 'CuentaPorCobrar',
            name: 'Cuentas por Cobrar',
            model: false,
            subItems: false
          },
          {
            num: 2,
            icon: 'mdi-cart',
            permiso: 'CuentaPorPagar',
            ruta: 'CuentaPorPagar',
            name: 'Cuentas por Pagar',
            model: false,
            subItems: false
          },
          {
            icon: 'mdi-cart',
            permiso: 'Cuenta',
            ruta: 'Cuenta',
            name: 'Plan de cuentas',
            model: false,
            subItems: false,
            num: 3
          },
          {
            icon: 'mdi-bank',
            permiso: 'Banco',
            ruta: 'Banco',
            name: 'Bancos',
            model: false,
            subItems: false,
            num: 4
          },
          {
            icon: 'mdi-bank',
            permiso: 'Concepto',
            ruta: 'Concepto',
            name: 'Conceptos',
            model: false,
            subItems: false,
            num: 5
          },
          {
            icon: 'mdi-bank',
            permiso: 'Pago',
            ruta: 'Pago',
            name: 'Lista de Cobros',
            model: false,
            subItems: false,
            num: 6
          },
          {
            icon: 'mdi-bank',
            permiso: 'CuentaPorPagar',
            ruta: 'Pagocxp',
            name: 'Lista de Pagos',
            model: false,
            subItems: false,
            num: 7
          },
          {
            icon: 'mdi-bank',
            permiso: 'NotaCredito',
            ruta: 'NotaCredito',
            name: 'Notas de Credito',
            model: false,
            subItems: false,
            num: 8
          },
          {
            icon: 'mdi-bank',
            permiso: 'NotaDebito',
            ruta: 'NotaDebito',
            name: 'Notas de Debito',
            model: false,
            subItems: false,
            num: 9
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-cart-arrow-up ',
        text: 'Ventas',
        model: false,
        array: [
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Clientes',
            model: false,
            subItems: true,
            num: 5,
            children: [
              {
                num: 1,
                icon: 'mdi-account-group',
                permiso: 'Cliente',
                ruta: 'Cliente',
                name: 'Ver'
              },
              {
                num: 2,
                icon: 'mdi-account-settings',
                permiso: 'TipoCliente',
                ruta: 'TipoCliente',
                name: 'Tipos'
              }
            ]
          },
          {
            icon: 'mdi-format-list-checks',
            permiso: 'FacturaPedido',
            ruta: 'FacturaPedido',
            name: 'Facturar',
            model: false,
            subItems: false,
            num: 2
          },
          {
            icon: 'mdi-cart-arrow-up',
            permiso: 'Venta',
            ruta: 'Venta',
            name: 'Listar Ventas',
            model: false,
            subItems: false,
            num: 4
          },
          {
            icon: 'mdi-format-list-checkbox',
            permiso: 'Pedido',
            ruta: 'Pedido',
            name: 'Pedidos',
            model: false,
            subItems: false,
            num: 1
          },
          {
            icon: 'mdi-routes',
            permiso: 'Zona',
            ruta: 'Zona',
            model: false,
            name: 'Zonas',
            subItems: false,
            num: 8
          },
          {
            icon: 'mdi-bus-stop',
            permiso: 'Ruta',
            ruta: 'Ruta',
            model: false,
            name: 'Rutas',
            subItems: false,
            num: 9
          },
          {
            icon: 'mdi-briefcase ',
            permiso: 'Portafolio',
            ruta: 'Portafolio',
            model: false,
            name: 'Portafolios',
            subItems: false,
            num: 7
          },
          {
            icon: 'mdi-account-tie',
            permiso: 'Vendedor',
            ruta: 'Vendedor',
            name: 'Vendedores',
            model: false,
            subItems: false,
            num: 6
          },
          {
            icon: 'mdi-format-list-checks',
            permiso: 'ListadoProducto',
            ruta: 'ListadoProducto',
            name: 'Listado de Productos',
            model: false,
            subItems: false,
            num: 10
          },
          {
            icon: 'mdi-format-list-checks',
            permiso: 'FacturaPedido',
            ruta: 'pos',
            name: 'POS',
            model: false,
            subItems: false,
            num: 11
          },
          {
            icon: 'mdi-format-list-checks',
            permiso: 'NotaEntrega',
            ruta: 'NotaEntrega',
            name: 'Notas de entrega',
            model: false,
            subItems: false,
            num: 3
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-lan-connect ',
        text: 'Intranet',
        model: false,
        array: [
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Empresas',
            model: false,
            subItems: true,
            num: 1,
            children: [
              {
                num: 1,
                icon: 'mdi-home-currency-usd',
                permiso: 'Empresa',
                ruta: 'Empresa',
                name: 'Ver'
              },
              {
                num: 2,
                icon: 'mdi-home-city',
                permiso: 'Departamento',
                ruta: 'Departamento',
                name: 'Departamentos'
              }
            ]
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Empleados',
            model: false,
            subItems: true,
            num: 2,
            children: [
              {
                num: 1,
                icon: 'mdi-account-settings',
                permiso: 'Empleado',
                ruta: 'Empleado',
                name: 'Ver'
              },
              {
                num: 2,
                icon: 'mdi-account-settings',
                permiso: 'TipoEmpleado',
                ruta: 'TipoEmpleado',
                name: 'Tipos'
              }
            ]
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Zona Geografica',
            model: false,
            subItems: true,
            num: 4,
            children: [
              {
                num: 1,
                icon: 'mdi-account-multiple-plus',
                permiso: 'Estado',
                ruta: 'Estado',
                name: 'Estado'
              },
              {
                num: 2,
                icon: 'mdi-account-multiple-plus',
                permiso: 'Municipio',
                ruta: 'Municipio',
                name: 'Municipio'
              },
              {
                num: 3,
                icon: 'mdi-account-multiple-plus',
                permiso: 'Parroquia',
                ruta: 'Parroquia',
                name: 'Parroquia'
              }
            ]
          },
          {
            icon: 'mdi-account-multiple-plus',
            permiso: 'Usuario',
            ruta: 'Usuario',
            name: 'Usuarios',
            model: false,
            subItems: false,
            num: 3
          },
          {
            icon: 'mdi-account-tie',
            permiso: 'TipoPago',
            ruta: 'TipoPago',
            name: 'Tipos de Pagos',
            model: false,
            subItems: false,
            num: 5
          },
          {
            icon: 'mdi-account-tie',
            permiso: 'Configuracion',
            ruta: 'Propiedades',
            name: 'Propiedades',
            model: false,
            subItems: false,
            num: 6
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-account-supervisor',
        text: 'Promotores',
        model: false,
        array: [
          {
            icon: 'mdi-calendar-multiselect',
            permiso: 'Planificacion',
            ruta: 'PlanificacionPromotor',
            name: 'Planificacion',
            model: false,
            subItems: false,
            num: 1
          },
          {
            icon: 'mdi-account-child-outline',
            permiso: 'EjecucionEstrategica',
            ruta: 'EjecucionEstrategica',
            name: 'Ejecucion Estrategica',
            model: false,
            subItems: false,
            num: 2
          },
          {
            icon: 'mdi-account-child-outline',
            permiso: 'EjecucionPlanificacion',
            ruta: 'EjecucionPlanificacion',
            name: 'Ejecucion de planificacion',
            model: false,
            subItems: false,
            num: 3
          }
        ]
      }
    ],
    itemsPer: [
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-chart-bar ',
        text: 'Operaciones',
        model: false,
        array: [
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Productos',
            model: false,
            subItems: true,
            num: 3,
            children: []
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Fabricantes',
            model: false,
            subItems: true,
            num: 5,
            children: []
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Inventario',
            model: false,
            subItems: true,
            num: 4,
            children: []
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Despacho',
            model: false,
            subItems: true,
            num: 6,
            children: []
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-square-inc-cash ',
        text: 'Tesoreria',
        model: false,
        array: [
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Reportes',
            model: false,
            subItems: true,
            num: 9,
            children: []
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-cart-arrow-up ',
        text: 'Ventas',
        model: false,
        array: [
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Clientes',
            model: false,
            subItems: true,
            num: 4,
            children: []
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-lan-connect ',
        text: 'Intranet',
        model: false,
        array: [
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Empresas',
            model: false,
            subItems: true,
            num: 2,
            children: []
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Empleados',
            model: false,
            subItems: true,
            num: 3,
            children: []
          },
          {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Zona Geografica',
            model: false,
            subItems: true,
            num: 5,
            children: []
          },
          {
            icon: 'mdi-account-tie',
            ruta: 'Perfil',
            name: 'Perfil',
            model: false,
            subItems: false,
            num: 7
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        icon2: 'mdi-account-supervisor',
        text: 'Promotores',
        model: false,
        array: []
      }
    ],
    items2: [
      /* {
        icon: 'notifications_active',
        icon2: 'headset_mic',
        ruta: 'Soporte',
        name: 'Soporte',
        permiso: 'Soporte',
        model: false
      } */
    ],
    items2Per: [
      {
        icon2: 'mdi-ferry',
        ruta: 'Importacion',
        name: 'Importaciones',
        permiso: 'Importacion',
        model: false
      },
      {
        icon2: 'mdi-clipboard-list',
        ruta: 'ImportacionOrdPendientes',
        name: 'Ord. Pendientes',
        permiso: 'Importacion',
        model: false
      },
      {
        icon2: 'mdi-account-cash',
        ruta: 'ImportacionTarifa',
        name: 'Tarifas',
        permiso: 'Importacion',
        model: false
      }
    ]
  }),
  sockets: {
    soport (data) {
      if (
        data.id_cliente.toString() === this.$store.state.usuario._id.toString()
      ) {
        this.noti = true
      }
    }
  },

  created () {
    /* EventBus.$on('resp', data => {
      this.verificarNoti()
    }) */
    EventBus.$on('actualizacionTasaMenu', data => {
      this.configuracion()
    })
    if (this.$store.state.usuario.master) {
      this.master = this.$store.state.usuario.master
      for (let i = 0; i < this.$store.state.empresa.length; i++) {
        if (
          this.$store.state.empresa[i].idEmpresa._id === this.$store.state.idempresa.idempresa
        ) {
          this.nameEmpresa = this.$store.state.empresa[i].idEmpresa.nombre
        }
      }
    } else {
      this.master = this.$store.state.usuario._id
      for (let i = 0; i < this.$store.state.empresa.length; i++) {
        if (
          this.$store.state.empresa[i].idEmpresa._id === this.$store.state.idempresa.idempresa
        ) {
          this.nameEmpresa = this.$store.state.empresa[i].idEmpresa.nombre
        }
      }
    }
    this.initialize()
    this.initialize2()
  },

  methods: {
    initialize () {
      this.RutaPermiso()
      this.bubbleSort()
      this.listarEmpresas()
      // this.verificarNoti()
    },
    initialize2 () {
      this.configuracion()
    },

    configuracion () {
      Api.get('configuracion')
        .then(response => {
          this.tasaD = []
          this.tasa = 0
          this.tasaD.push(response.data.tasa.tasaDia.valor)
          this.tasa = formatoDecimal(this.tasaD[0])
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    limpiar () {
      this.tasa = 0
    },

    actualizarTasa (tasa) {
      this.dialog = true
    },

    /* verificarNoti () {
      Api.get('soporte').then(res => {
        if (res.data[0] && res.data[0].estatus === 'Atendido') {
          this.noti = true
        } else {
          this.noti = false
        }
      })
    }, */

    listarEmpresas () {
      Api.get('empresa/all')
        .then(res => {
          res.data.map(empresa => {
            this.idEmpresaArray.push({
              text: empresa.nombre,
              value: empresa._id
            })
          })
        })
        .catch(err => console.log(err))
    },

    RutaPermiso () {
      let arr = this.$store.state.usuario
      let arr2 = this.items
      let arr3 = this.itemsPer
      let arr4 = this.items2
      let arr5 = this.items2Per

      arr.Empresa[0].permisos.map((data1, i) => {
        arr2.map((data2, j) => {
          data2.array.map((data3, k) => {
            if (data3.subItems) {
              data3.children.map((data4, l) => {
                if (data4.permiso === data1.ruta) {
                  arr3[j].array[k].children.push(data4)
                }
              })
            } else {
              if (data3.permiso === data1.ruta) {
                arr3[j].array.push(data3)
              }
            }
          })
        })
        arr4.map((data2, j) => {
          if (data2.permiso === data1.ruta) {
            arr5.push(data2)
          }
        })
      })

      if (arr.permisos) {
        arr.permisos.map((data1, i) => {
          arr2.map((data2, j) => {
            data2.array.map((data3, k) => {
              if (data3.subItems) {
                data3.children.map((data4, l) => {
                  if (data4.permiso === data1.ruta) {
                    arr3[j].array[k].children.push(data4)
                  }
                })
              } else {
                if (data3.permiso === data1.ruta) {
                  arr3[j].array.push(data3)
                }
              }
            })
          })
        })
      }

      arr3.map((data, i) => {
        let bool = false
        data.array.map((data2, j) => {
          if (data2.subItems) {
            if (data2.children.length === 0) {
              arr3[i].array.splice(j, j)
            } else {
              bool = true
            }
          }
        })
      })
      this.itemsPer = arr3
    },

    bubbleSort () {
      let lista = this.itemsPer
      let n, i, k, aux, n2, i2, k2, aux2
      lista.map(data => {
        n = data.array.length
        for (k = 1; k < n; k++) {
          for (i = 0; i < n - k; i++) {
            if (data.array[i].subItems) {
              n2 = data.array[i].children.length
              for (k2 = 1; k2 < n2; k2++) {
                for (i2 = 0; i2 < n2 - k2; i2++) {
                  if (
                    data.array[i].children[i2].num >
                    data.array[i].children[i2 + 1].num
                  ) {
                    aux2 = data.array[i].children[i2]
                    data.array[i].children[i2] = data.array[i].children[i2 + 1]
                    data.array[i].children[i2 + 1] = aux2
                  }
                }
              }
            }
            if (data.array[i].num > data.array[i + 1].num) {
              aux = data.array[i]
              data.array[i] = data.array[i + 1]
              data.array[i + 1] = aux
            }
          }
        }
      })
      this.itemsPer = lista
    },

    logout () {
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que desea Salir?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Salir'
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('logout')
          this.$cookies.remove('token')
          this.$cookies.remove('log')
          window.location.href = '/login'
        }
      })
    },

    aceptar (item) {
      this.model.idempresa = item
      Api.post('/login/select', this.model)
        .then(res => {
          if (res.data.status === 'Success') {
            this.$store.dispatch('config', res.data.config)
            this.$store.dispatch('empresa', this.model)
            this.$cookies.set('token', res.data.token, '5D', '')
            this.$cookies.set('log', 'lleno')
            window.location.reload()
          } else {
            this.$swal(
              'Oops...',
              'Empresa no encontrada, revise su informacion',
              'error'
            )
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    close () {
      this.dialog = false
      this.tasa = formatoDecimal(this.tasaD[0])
    },

    save () {
      let array = {
        _id: this.$store.state.config._id,
        valor: this.tasa
      }
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      Api.put('configuracion/tasa', array)
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: 'Modificación exitosa',
            text: 'Tasa actualizada'
          })
          this.$store.dispatch('configTasa', array.valor)
          EventBus.$emit('actualizacionTasaProducto', '0')
          EventBus.$emit('actualizacionTasaPropiedades', '0')
          this.initialize2()
          this.dialog = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error encontrado!',
              text: 'Verifique los datos o llame al administrador.'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    }
  }
}
</script>
